<template>
    <TsCard data-testid="my-account-pro-card-user-card" noBorder noShadow append-class="p-0 m-0 bg-white relative">
        <TsImage data-testid="my-account-pro-card-user-card-image" src="/images/pro-card.png" width="509"
            loading="lazy" />
        <TsRow class="flex justify-between w-full mb-4 pl-3 absolute bottom-2 px-2 md:pr-7 md:pl-5">
            <TsColumn class="is-8 flex justify-end flex-col">
                <TsTypography data-testid="my-account-pro-card-user-card-name"
                    append-class="text-primary text-2xl font-bold max-w-60 line-clamp-2 !mb-1">
                    {{ name }}
                </TsTypography>
                <TsTypography data-testid="my-account-pro-card-user-card-name"
                    class=" text-primary text-base font-semibold">
                    {{ useTranslation('proCard', 'Pro-Kaart') }}
                </TsTypography>
            </TsColumn>
            <TsColumn append-class="bg-white p-2 rounded-md is-4">
                <div v-html="svgString" />
            </TsColumn>
        </TsRow>
    </TsCard>
</template>

<script setup lang="ts">
import { computed } from "vue";
const { isMobile } = useDevice();

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const authStore = useAuthStore();

const name = computed(() => authStore.user && authStore?.user?.first_name + " " + authStore?.user?.last_name)
const encodedQrCode = computed(() => authStore.user && authStore?.user?.one_time_qr_code_base64)
let decodedQrCode = null;
if (import.meta.client) decodedQrCode = window.atob(encodedQrCode.value);
let svgElement = new DOMParser().parseFromString(decodedQrCode, "image/svg+xml").documentElement;
svgElement.setAttribute('width', `${isMobile ? '90' : '140'}`);
svgElement.setAttribute('height', `${isMobile ? '90' : '140'}`);
let svgString = new XMLSerializer().serializeToString(svgElement);

</script>